/** @jsx jsx */
import { jsx } from 'theme-ui';
import { theme, useConfig, ComponentsProvider } from 'docz';
import { Styled, ThemeProvider } from 'theme-ui';
import defaultTheme from '~theme';
import components from '~components';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Theme = function Theme(_ref) {
  var children = _ref.children;
  var config = useConfig();
  return jsx(ThemeProvider, {
    theme: config.themeConfig
  }, jsx(ComponentsProvider, {
    components: components
  }, jsx(Styled.root, null, children)));
};

export default theme(defaultTheme)(Theme);